"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5206],{

/***/ 86169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var services_validators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82257);
/* harmony import */ var react_phone_number_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58185);


var brokerClient = function(values) {
    var errors = {};
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.name)) {
        errors.name = 'Nombre requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.firstName)) {
        errors.firstName = 'Nombre requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.lastName)) {
        errors.lastName = 'Apellido requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.street)) {
        errors.street = 'Calle requerida';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.streetNumber)) {
        errors.streetNumber = 'N\xfamero exterior requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.state)) {
        errors.state = 'Estado requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.neighborhood)) {
        errors.neighborhood = 'Colonia requerida';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.district)) {
        errors.district = 'Municipio requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.city)) {
        errors.city = 'Ciudad requerida';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.email)) {
        errors.email = 'Email requerido';
    } else if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validEmail */ .u$)(values.email)) {
        errors.email = 'Email inv\xe1lido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.telephone)) {
        errors.telephone = 'Tel\xe9fono requerido';
    } else if (!(0,react_phone_number_input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values.telephone)) {
        errors.telephone = 'Tel\xe9fono inv\xe1lido';
    }
    if ((0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.secondTelephone) && !(0,react_phone_number_input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values.secondTelephone)) {
        errors.secondTelephone = 'Tel\xe9fono inv\xe1lido';
    }
    if ((0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.mobilePhone) && !(0,react_phone_number_input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values.mobilePhone)) {
        errors.mobilePhone = 'Tel\xe9fono inv\xe1lido';
    }
    if ((0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.secondMobilePhone) && !(0,react_phone_number_input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values.secondMobilePhone)) {
        errors.secondMobilePhone = 'Tel\xe9fono inv\xe1lido';
    }
    return errors;
};
/* harmony default export */ __webpack_exports__["Z"] = (brokerClient);


/***/ }),

/***/ 55206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Landing_ContactFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
// EXTERNAL MODULE: ./app/theme/fonts.js
var fonts = __webpack_require__(18437);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
;// CONCATENATED MODULE: ./components/Landing/ContactFooter/style.js



var _defaultExport = new String(".contact-footer-container{flex-wrap:wrap;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:start;\n-webkit-box-align:start;\n-ms-flex-align:start;\nalign-items:start;\nwidth:100%;\nmin-height:28.12500rem;\nbackground-image:url(".concat((0,services/* image */.BH)('/landing/contact/bg-contact-sillon.jpg'), ");\nbackground-repeat:no-repeat;\nbackground-size:cover;\nbackground-position-x:center;\npadding-left:50%}\nh3{max-width:33.18rem;\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(fonts/* fontSizes.h1 */.CH.h1, ";\ntext-align:left;\ncolor:").concat(theme/* colors.text */.O9.text, "}\n.success-message{width:350px;\nheight:635px;\ntext-align:center;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:columns;\n-ms-flex-direction:columns;\nflex-direction:columns;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\n.success-message h1{color:").concat(theme/* colors.primary */.O9.primary, ";\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfontSizes:").concat(fonts/* fontSizes.h1 */.CH.h1, "}"));
_defaultExport.__hash = "b7f01f9f269a1bb8";
/* harmony default export */ var style = (_defaultExport);

// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./app/services/store/index.js + 1 modules
var store = __webpack_require__(27293);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/redux-form/es/Field.js + 8 modules
var Field = __webpack_require__(44515);
// EXTERNAL MODULE: ./node_modules/redux-form/es/reduxForm.js + 13 modules
var reduxForm = __webpack_require__(78938);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
// EXTERNAL MODULE: ./controls/Input/index.js
var Input = __webpack_require__(24493);
// EXTERNAL MODULE: ./controls/Button/index.js + 17 modules
var Button = __webpack_require__(68030);
// EXTERNAL MODULE: ./controls/utils/react-flexbox-grid.js
var react_flexbox_grid = __webpack_require__(91584);
// EXTERNAL MODULE: ./node_modules/react-ios-switch/lib/index.js
var lib = __webpack_require__(11426);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/Rgpd/index.js + 1 modules
var Rgpd = __webpack_require__(15426);
// EXTERNAL MODULE: ./globalConfigApp/index.js + 1 modules
var globalConfigApp = __webpack_require__(19169);
// EXTERNAL MODULE: ./controls/PhoneInput/index.js + 1 modules
var PhoneInput = __webpack_require__(79790);
;// CONCATENATED MODULE: ./components/Forms/ContactForm/style.js


var style_defaultExport = new String(".form-container.jsx-52d06aa7db98262f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nheight:auto;\nmargin:200px auto 0;\nmax-width:540px;\nwidth:100%}\n@media (max-width:991px) {.form-container.jsx-52d06aa7db98262f{margin-top:0}}\nh4.jsx-52d06aa7db98262f{font:".concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(fonts/* fontSizes.h4 */.CH.h4, ";\ntext-align:left;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0px}\n.legend.jsx-52d06aa7db98262f{font-family:'Source Sans Pro', sans-serif;\nfont-size:14px;\ntext-align:left;\ncolor:").concat(theme/* colors.lightText */.O9.lightText, ";\nmargin:10px auto 0px auto}\n.terms.jsx-52d06aa7db98262f{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:10px;\ntext-align:center;\nmax-width:350px;\nmargin-left:auto;\nmargin-right:auto;\ncolor:").concat(theme/* colors.lightText */.O9.lightText, "}\n.terms-link.jsx-52d06aa7db98262f{color:").concat(theme/* colors.secondary */.O9.secondary, "}\n.form-container.jsx-52d06aa7db98262f .actions{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column}\n.form-container.jsx-52d06aa7db98262f .submit{margin:10px 0}\n.action-switch.jsx-52d06aa7db98262f{margin-bottom:0px}\n.switch-container.jsx-52d06aa7db98262f{height:100%;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:right;\njustify-content:right;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}"));
style_defaultExport.__hash = "52d06aa7db98262f";
/* harmony default export */ var ContactForm_style = (style_defaultExport);

// EXTERNAL MODULE: ./components/Forms/styles.js
var styles = __webpack_require__(59889);
;// CONCATENATED MODULE: ./components/Forms/ContactForm/index.js


















function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ContactForm = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ContactForm, Component1);
    var _super = _createSuper(ContactForm);
    function ContactForm(props) {
        _classCallCheck(this, ContactForm);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "toggleExperience", function() {
            _this.setState({
                hasExperience: !_this.state.hasExperience
            });
        });
        _this.state = {
            hasExperience: true,
            checkedRgpd: !(0,globalConfigApp/* isContentCountry */.I2)([
                'es'
            ])
        };
        return _this;
    }
    _createClass(ContactForm, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var checkedRgpd1 = this.state.checkedRgpd;
                var _props = this.props, handleSubmit = _props.handleSubmit, invalid = _props.invalid, style = _props.style, centered = _props.centered;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    style: style,
                    className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "form-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "chatbubbles",
                                    style: {
                                        fontSize: '20px',
                                        color: theme/* colors.articBlue */.O9.articBlue,
                                        marginRight: '10px'
                                    }
                                }),
                                "Cont\xe1ctanos ahora"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "legend",
                            children: " "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        className: "form-input-margin",
                                        name: "name",
                                        id: "name",
                                        component: Input/* InputForm */.M5,
                                        placeholder: "Nombre"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        className: "form-input-margin",
                                        name: "lastName",
                                        id: "lastName",
                                        component: Input/* InputForm */.M5,
                                        placeholder: "Apellido(s)"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                    className: "form-input-margin",
                                    name: "address",
                                    id: "address",
                                    component: Input/* InputForm */.M5,
                                    placeholder: "Direcci\xf3n"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                    className: "form-input-margin",
                                    name: "neighborhood",
                                    id: "neighborhood",
                                    component: Input/* InputForm */.M5,
                                    placeholder: "Colonia y/o Municipio"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        className: "form-input-margin",
                                        name: "city",
                                        id: "city",
                                        component: Input/* InputForm */.M5,
                                        placeholder: "Ciudad"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        className: "form-input-margin",
                                        name: "zipCode",
                                        id: "zipCode",
                                        component: Input/* InputForm */.M5,
                                        placeholder: "C\xf3digo Postal"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "label action-switch",
                                        children: "Tiene experiencia en Bienes Ra\xedces"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "switch-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                pendingOnColor: theme/* colors.primary */.O9.primary,
                                                checked: this.state.hasExperience,
                                                onChange: this.toggleExperience
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                name: "hasExperience",
                                                id: "hasExperience",
                                                component: Input/* InputHidden */.Rn,
                                                currentValue: this.state.hasExperience
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                    className: "form-input-margin",
                                    name: "email",
                                    id: "email",
                                    component: Input/* InputForm */.M5,
                                    placeholder: "Correo Electr\xf3nico"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                    className: "form-input-margin",
                                    name: "telephone",
                                    id: "telephone",
                                    component: PhoneInput/* default */.Z,
                                    placeholder: "Tel\xe9fono"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rgpd/* default */.Z, {
                            handleValidRgpd: function(checkedRgpd) {
                                return _this.setState({
                                    checkedRgpd: checkedRgpd
                                });
                            },
                            checkedRgpd: checkedRgpd1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Col, {
                                xs: 12,
                                className: "actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "primary",
                                        fullWidth: true,
                                        type: "submit",
                                        className: "submit",
                                        disabled: invalid && !checkedRgpd1,
                                        children: "Contactar"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "terms",
                                        children: [
                                            "Al hacer clic en \"Contactar\" estoy de acuerdo con los",
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(styles/* common.__hash */.y0.__hash, " jsx-").concat(ContactForm_style.__hash) + " " + "terms-link",
                                                children: "T\xe9rminos y Condiciones"
                                            }),
                                            " para recibir informaci\xf3n de parte de ",
                                            globalConfigApp/* companyConfig.name */.p2.name,
                                            "."
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: ContactForm_style.__hash,
                            children: ContactForm_style
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: styles/* common.__hash */.y0.__hash,
                            children: styles/* common */.y0
                        })
                    ]
                }));
            }
        }
    ]);
    return ContactForm;
}(react.Component);
_defineProperty(ContactForm, "propTypes", {
    style: (prop_types_default()).object,
    centered: (prop_types_default()).bool
});
_defineProperty(ContactForm, "defaultProps", {
    style: {},
    centered: false
});
var formConfig = {
    form: 'ContactForm'
};
/* harmony default export */ var Forms_ContactForm = ((0,reduxForm/* default */.Z)(formConfig)(ContactForm));

// EXTERNAL MODULE: ./app/validators/brokerClient.js
var brokerClient = __webpack_require__(86169);
;// CONCATENATED MODULE: ./components/Landing/ContactFooter/index.js










function ContactFooter_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ContactFooter_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ContactFooter_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ContactFooter_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ContactFooter_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ContactFooter_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ContactFooter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContactFooter_getPrototypeOf(o) {
    ContactFooter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ContactFooter_getPrototypeOf(o);
}
function ContactFooter_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ContactFooter_setPrototypeOf(subClass, superClass);
}
function ContactFooter_possibleConstructorReturn(self, call) {
    if (call && (ContactFooter_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ContactFooter_assertThisInitialized(self);
}
function ContactFooter_setPrototypeOf(o, p) {
    ContactFooter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ContactFooter_setPrototypeOf(o, p);
}
var ContactFooter_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ContactFooter_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ContactFooter_createSuper(Derived) {
    var hasNativeReflectConstruct = ContactFooter_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ContactFooter_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ContactFooter_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ContactFooter_possibleConstructorReturn(this, result);
    };
}
var ContactFooter = /*#__PURE__*/ function(Component1) {
    "use strict";
    ContactFooter_inherits(ContactFooter, Component1);
    var _super = ContactFooter_createSuper(ContactFooter);
    function ContactFooter(props) {
        ContactFooter_classCallCheck(this, ContactFooter);
        var _this;
        _this = _super.call(this, props);
        ContactFooter_defineProperty(ContactFooter_assertThisInitialized(_this), "closeModal", function() {
            _this.setState({
                isModalOpen: false,
                success: false
            });
        });
        ContactFooter_defineProperty(ContactFooter_assertThisInitialized(_this), "openModal", function() {
            return _this.setState({
                isModalOpen: true
            });
        });
        ContactFooter_defineProperty(ContactFooter_assertThisInitialized(_this), "submit", function(values) {
            _this.props.actions.sendContactInfo(values);
        });
        _this.state = {
            isModalOpen: false,
            success: false
        };
        return _this;
    }
    ContactFooter_createClass(ContactFooter, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.contactInfoRequestData.loading && nextProps.contactInfoRequestData.finished && !nextProps.contactInfoRequestData.error) {
                    this.setState({
                        success: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var title = this.props.title;
                var success = this.state.success;
                var modalContent = null;
                if (success) {
                    modalContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "success-message",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Mensaje enviado"
                        })
                    });
                } else {
                    modalContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_ContactForm, {
                        onSubmit: this.submit,
                        validate: brokerClient/* default */.Z,
                        style: {
                            padding: '0 20px',
                            margin: '20px 0px 0px',
                            maxWidth: '350px'
                        },
                        centered: true
                    });
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contact-footer-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Modal */.u_, {
                            isOpen: this.state.isModalOpen,
                            onClose: this.closeModal,
                            width: "100%",
                            maxWidth: "350px",
                            children: modalContent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                            onClick: this.openModal,
                            style: {
                                padding: '10px 64px 13px 65px',
                                maxWidth: '160px'
                            },
                            size: "medium",
                            color: "primary",
                            children: "\xdanete"
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: style.__hash,
                            children: style
                        })
                    ]
                }));
            }
        }
    ]);
    return ContactFooter;
}(react.Component);
ContactFooter_defineProperty(ContactFooter, "defaultProps", {
    title: '\xdanete a nuestra Alianza. Estamos a tus \xf3rdenes.'
});
var mapStateToProps = function(state) {
    return {
        contactInfoRequestData: store/* default.footerContact */.Z.footerContact('contact').selector(state)
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            sendContactInfo: store/* default.footerContact */.Z.footerContact('contact').action
        }, dispatch)
    };
};
/* harmony default export */ var Landing_ContactFooter = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ContactFooter));


/***/ }),

/***/ 15426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RgpdCoponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./globalConfigApp/index.js + 1 modules
var globalConfigApp = __webpack_require__(19169);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/Rgpd/styles.js

var _defaultExport = new String(".tandc.jsx-3ce7ebe43f9e2f36{color:".concat(theme/* colors.primary */.O9.primary, "}\np.jsx-3ce7ebe43f9e2f36{font-size:.7rem}"));
_defaultExport.__hash = "3ce7ebe43f9e2f36";
/* harmony default export */ var styles = (_defaultExport);

;// CONCATENATED MODULE: ./components/Rgpd/index.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var RgpdCoponent = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(RgpdCoponent, Component1);
    var _super = _createSuper(RgpdCoponent);
    function RgpdCoponent() {
        _classCallCheck(this, RgpdCoponent);
        return _super.apply(this, arguments);
    }
    _createClass(RgpdCoponent, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                var checkedRgpd = this.props.checkedRgpd;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(styles.__hash) + " " + "esp",
                    children: [
                        (0,globalConfigApp/* isContentCountry */.I2)([
                            'es'
                        ]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(styles.__hash),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "jsx-".concat(styles.__hash),
                                    children: [
                                        "Conforme al RGPD y la LOPDGDD, ",
                                        globalConfigApp/* companyConfig.name */.p2.name,
                                        " ESPA\xd1A tratar\xe1 los datos facilitados, con la finalidad de contestar las solicitudes de informaci\xf3n recibidas a trav\xe9s del presente formulario. Podr\xe1 ejercer, si lo desea, los derechos de acceso, rectificaci\xf3n, supresi\xf3n, y dem\xe1s reconocidos en la normativa mencionada. Para obtener m\xe1s informaci\xf3n acerca de c\xf3mo estamos tratando sus datos, acceda a nuestra pol\xedtica de privacidad."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "jsx-".concat(styles.__hash),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            name: "rgdp",
                                            checked: checkedRgpd,
                                            onClick: function(e) {
                                                return _this.props.handleValidRgpd(e.target.checked);
                                            },
                                            className: "jsx-".concat(styles.__hash)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "jsx-".concat(styles.__hash),
                                            children: " ENTIENDO Y ACEPTO "
                                        }),
                                        " el tratamiento de mis datos tal y como se describe  anteriormente y se explica con mayor detalle en la ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            className: "jsx-".concat(styles.__hash) + " " + "tandc",
                                            children: "Pol\xedtica de Privacidad"
                                        }),
                                        ". (Su negativa a facilitarnos la autorizaci\xf3n implicar\xe1 la imposibilidad de tratar sus datos con la finalidad indicada)."
                                    ]
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles.__hash,
                            children: styles
                        })
                    ]
                }));
            }
        }
    ]);
    return RgpdCoponent;
}(react.Component);
_defineProperty(RgpdCoponent, "propTypes", {
    handleValidRgpd: (prop_types_default()).func.isRequired,
    checkedRgpd: (prop_types_default()).bool.isRequired
});



/***/ })

}]);